module.exports = __webpack_public_path__ + "static/media/bcard-202009-4.4dde687a.jpg";